import { atomWithLocalStorage } from "../../storage";
import { ImageWithAltSpace, ImageWithNote } from "../../types";

interface PartialTaggingCache {
  venueId: string | null;
  venueName: string | null;
  categoryId: string | null;
  typeQuestionTagId: string | null;
  answers: { [key: number]: string[] };
  images: ImageWithNote[];
}

export const partialTaggingSaveAtom = atomWithLocalStorage<PartialTaggingCache>(
  "partialTaggingSave",
  {
    venueId: null,
    categoryId: null,
    typeQuestionTagId: null,
    answers: {},
    images: [],
    venueName: null,
  }
);

type PartialTaggingComplexSpaceAtom = {
  spaceName: string | null;
  venueId: string | null;
  reviewId: string | null;
  reviewLevelId: string | null;
  imageData: ImageWithAltSpace[];
  currentImage: number;
  answers: { [key: number]: string[] };
};

export const partialTaggingComplexSpaceAtom =
  atomWithLocalStorage<PartialTaggingComplexSpaceAtom>(
    "partialTaggingComplexSpace",
    {
      spaceName: null,
      venueId: null,
      reviewId: null,
      reviewLevelId: null,
      imageData: [],
      currentImage: -1,
      answers: {},
    }
  );
